// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq-section .custom-container .content-section {
  background: #E0E7FF;
  padding: 4rem 1rem;
  min-height: 55vh;
}
.faq-section .custom-container .content-section .page-title {
  font-size: 2.2rem;
  text-align: center;
  color: #08245A;
}
.faq-section .custom-container .content-section .page-title::after {
  content: "";
  display: block;
  height: 8px;
  width: 60px;
  background: #08245A;
  margin: 0.7rem auto 0;
  border-radius: 20px;
}
.faq-section .custom-container .content-section .content-body {
  max-width: 900px;
  margin: 3rem auto 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/pages/faq/style.scss","webpack://./src/assets/css/common/_variables.scss"],"names":[],"mappings":"AAKI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;AAJN;AAMM;EACE,iBCEK;EDDL,kBAAA;EACA,cAAA;AAJR;AAMQ;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAJV;AAQM;EACE,gBAAA;EACA,mBAAA;AANR","sourcesContent":["@import \"./src/assets/css/common/variables\";\r\n\r\n.faq-section {\r\n\r\n  .custom-container {\r\n    .content-section {\r\n      background: #E0E7FF;\r\n      padding: 4rem 1rem;\r\n      min-height: 55vh;\r\n\r\n      .page-title {\r\n        font-size: $page-title;\r\n        text-align: center;\r\n        color: #08245A;\r\n\r\n        &::after {\r\n          content: \"\";\r\n          display: block;\r\n          height: 8px;\r\n          width: 60px;\r\n          background: #08245A;\r\n          margin: .7rem auto 0;\r\n          border-radius: 20px;\r\n        }\r\n      }\r\n\r\n      .content-body {\r\n        max-width: 900px;\r\n        margin: 3rem auto 0;\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Color palette\r\n$color-blue-light: #d0dbff;\r\n$color-blue: #354e80;\r\n$color-blue-dark: #1c2f56;\r\n\r\n$color-sky: #e0e7ff;\r\n\r\n$color-yellow-light: #fffdef;\r\n$color-yellow: #fae205;\r\n\r\n$color-black-30: #e1e2e2;\r\n\r\n$section-heading-font-size: 2.1rem;\r\n$page-title: 2.2rem;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
